import { render, staticRenderFns } from "./typeSerieResume.vue?vue&type=template&id=3b63da9c&scoped=true&"
import script from "./typeSerieResume.vue?vue&type=script&lang=js&"
export * from "./typeSerieResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b63da9c",
  null
  
)

export default component.exports